export enum ProductRecommendationsErrors {
    Default = 'PRODUCT_RECOMMENDATIONS_ERROR',
}
